// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.quickMenuCardContainer {
  border: 1px solid var(--surface-g1);
  border-radius: 8px;
  padding: 10px;
  width: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.cardMenuImage {
  height: 100px;
  width: 100%;
  flex-shrink: 0;
  position: relative;
}

.cardMenuImage img {
  height: 100%;
  width: 100%;
  object-fit: cover;
}

.statusChip {
  width: max-content;
  padding: 2px 6px;
  border-radius: 50px;
  color: var(--surface-white);
  font-weight: 700;
  position: absolute;
  top: 4px;
  right: 4px;
}

.statusChipActive {
  background-color: #4caf50;
}

.statusChipInactive {
  background-color: #f44336;
}

.cardDiateryContainer {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
}

.cardDiateryContainer p {
  white-space: normal;
  overflow: visible;
  text-overflow: unset;
  word-break: break-word;
  line-height: 1.3;
}

.cardMenuHeaderText {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  margin-top: 10px;
  gap: 8px;
  position: relative;
}

.QuickMenuCardSecondaryText {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-top: auto;
  padding-top: 12px;
}

.QuickMenuCardPriceContainer {
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: wrap;
}

.QuickMenuCardPrice {
  font-weight: 700;
  color: var(--surface-g5);
}

.QuickMenuCardShortcode {
  font-weight: 600;
  color: var(--surface-g4);
}
.quickMenuCardKebabIcon {
  flex-shrink: 0;
  cursor: pointer;
}

.quickMenuDropdown {
  position: absolute;
  top: 28px;
  right: 0;
  background: var(--surface-white);
  border: 1px solid var(--surface-g1);
  border-radius: 8px;
  padding: 12px;
  width: 100%;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.12);
  z-index: 10;
}

.quickMenuDropdownItem {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
}

.quickMenuDropdownItem span {
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--surface-g5);
}

/* Toggle */

.toggleSwitch {
  width: 42px;
  height: 22px;
  border-radius: 999px;
  border: none;
  position: relative;
  cursor: pointer;
  transition: all 0.2s ease;
  padding: 0 2px;
  display: flex;
  align-items: center;
}

.toggleOn {
  background: #22c55e;
  justify-content: flex-end;
}

.toggleOff {
  background: #cbd5e1;
  justify-content: flex-start;
}

.toggleCircle {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: white;
}

.menuDropdownWrapper {
  color: var(--surface-g3);
}

.quickMenuToggleDesc {
  margin-top: 4px;
}

/* ── No Inward badge ── */
.noInwardBadge {
  position: absolute;
  bottom: 4px;
  left: 4px;
  background-color: #f59e0b;
  color: #fff;
  font-size: 0.688rem;
  font-weight: 700;
  padding: 2px 6px;
  border-radius: 50px;
  white-space: nowrap;
  line-height: 1.4;
}

/* ── Dark mode ── */
.dark .quickMenuCardContainer {
  border-color: #334155;
  background-color: #0f172a;
  color: #f1f5f9;
}

.dark .quickMenuDropdown {
  background: #1e293b;
  border-color: #334155;
}

.dark .quickMenuDropdownItem span {
  color: #f1f5f9;
}

.dark .menuDropdownWrapper {
  color: #94a3b8;
}

.dark .QuickMenuCardPrice {
  color: #f1f5f9;
}

.dark .QuickMenuCardShortcode {
  color: #94a3b8;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/settings/components/CreateMenu/QuickMenuCard.css"],"names":[],"mappings":"AAAA;EACE,mCAAmC;EACnC,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,mCAAmC;EACnC,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,4CAA4C;EAC5C,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA,WAAW;;AAEX;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;AACjB;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,yBAAyB;EACzB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".quickMenuCardContainer {\n  border: 1px solid var(--surface-g1);\n  border-radius: 8px;\n  padding: 10px;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  box-sizing: border-box;\n}\n\n.cardMenuImage {\n  height: 100px;\n  width: 100%;\n  flex-shrink: 0;\n  position: relative;\n}\n\n.cardMenuImage img {\n  height: 100%;\n  width: 100%;\n  object-fit: cover;\n}\n\n.statusChip {\n  width: max-content;\n  padding: 2px 6px;\n  border-radius: 50px;\n  color: var(--surface-white);\n  font-weight: 700;\n  position: absolute;\n  top: 4px;\n  right: 4px;\n}\n\n.statusChipActive {\n  background-color: #4caf50;\n}\n\n.statusChipInactive {\n  background-color: #f44336;\n}\n\n.cardDiateryContainer {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-weight: 600;\n}\n\n.cardDiateryContainer p {\n  white-space: normal;\n  overflow: visible;\n  text-overflow: unset;\n  word-break: break-word;\n  line-height: 1.3;\n}\n\n.cardMenuHeaderText {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  width: 100%;\n  margin-top: 10px;\n  gap: 8px;\n  position: relative;\n}\n\n.QuickMenuCardSecondaryText {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  margin-top: auto;\n  padding-top: 12px;\n}\n\n.QuickMenuCardPriceContainer {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.QuickMenuCardPrice {\n  font-weight: 700;\n  color: var(--surface-g5);\n}\n\n.QuickMenuCardShortcode {\n  font-weight: 600;\n  color: var(--surface-g4);\n}\n.quickMenuCardKebabIcon {\n  flex-shrink: 0;\n  cursor: pointer;\n}\n\n.quickMenuDropdown {\n  position: absolute;\n  top: 28px;\n  right: 0;\n  background: var(--surface-white);\n  border: 1px solid var(--surface-g1);\n  border-radius: 8px;\n  padding: 12px;\n  width: 100%;\n  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.12);\n  z-index: 10;\n}\n\n.quickMenuDropdownItem {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n}\n\n.quickMenuDropdownItem span {\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: var(--surface-g5);\n}\n\n/* Toggle */\n\n.toggleSwitch {\n  width: 42px;\n  height: 22px;\n  border-radius: 999px;\n  border: none;\n  position: relative;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  padding: 0 2px;\n  display: flex;\n  align-items: center;\n}\n\n.toggleOn {\n  background: #22c55e;\n  justify-content: flex-end;\n}\n\n.toggleOff {\n  background: #cbd5e1;\n  justify-content: flex-start;\n}\n\n.toggleCircle {\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  background: white;\n}\n\n.menuDropdownWrapper {\n  color: var(--surface-g3);\n}\n\n.quickMenuToggleDesc {\n  margin-top: 4px;\n}\n\n/* ── No Inward badge ── */\n.noInwardBadge {\n  position: absolute;\n  bottom: 4px;\n  left: 4px;\n  background-color: #f59e0b;\n  color: #fff;\n  font-size: 0.688rem;\n  font-weight: 700;\n  padding: 2px 6px;\n  border-radius: 50px;\n  white-space: nowrap;\n  line-height: 1.4;\n}\n\n/* ── Dark mode ── */\n.dark .quickMenuCardContainer {\n  border-color: #334155;\n  background-color: #0f172a;\n  color: #f1f5f9;\n}\n\n.dark .quickMenuDropdown {\n  background: #1e293b;\n  border-color: #334155;\n}\n\n.dark .quickMenuDropdownItem span {\n  color: #f1f5f9;\n}\n\n.dark .menuDropdownWrapper {\n  color: #94a3b8;\n}\n\n.dark .QuickMenuCardPrice {\n  color: #f1f5f9;\n}\n\n.dark .QuickMenuCardShortcode {\n  color: #94a3b8;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
